import { c as _c } from "react/compiler-runtime";
import { HotelCard } from "@website/accommodation-ui/hotel-card-new";
import { HotelCardSuggestionCarouselPropertiesTypes } from "@website/accommodation-ui/hotel-cities-main-content/hotel-suggestion-carousel/hotel-suggestion-carrousel.types";
import { MaterialIcon } from "@website/icons/material";
import { CarouselV2 } from "@website/ui/carousel";
import { Skeleton } from "@website/ui/skeleton";
import set from "lodash-es/set";
import { useState } from "react";
export const HotelSuggestionCarousel = properties => {
  const $ = _c(11);
  const {
    hotelsSuggested,
    noFollow
  } = properties;
  const [isOpen, setIsOpen] = useState(hotelsSuggested?.length > 0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsOpen(false);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleClick = t0;
  const t1 = !isOpen;
  let t2;
  if ($[1] !== properties.loading) {
    t2 = <div className="text-subtitle-2 end-6 flex h-[34px] flex-row items-center justify-between pb-3 pe-6 lg:h-[28px]">{properties?.loading ? <Skeleton height={24} /> : <><div className="text-secondary">هتل های پیشنهادی</div><MaterialIcon className="text-secondary cursor-pointer" name="clear" onClick={handleClick} /></>}</div>;
    $[1] = properties.loading;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== hotelsSuggested || $[4] !== noFollow || $[5] !== properties.loading) {
    t3 = properties?.loading ? <Skeleton height={112} /> : <CarouselV2 itemClass="w-[277.33331px] px-2" key="suggested_hotels_carousel" keyCarousel="suggested_cities_carousel" list={hotelsSuggested?.slice(0, 6)?.map((hotelsSuggestionProperties, index) => <HotelCard index={index} hotelInfo={set(hotelsSuggestionProperties, "hotelDetail.hotelPageUrl.query.utm_source", "suggested_hotels")} key={hotelsSuggestionProperties.id} noFollow={noFollow} size="xSmall" isSuggestedCard={true} shouldRedirectUsingJs={true} />) || []} mode="free" options={{
      slides: {
        perView: "auto"
      }
    }} />;
    $[3] = hotelsSuggested;
    $[4] = noFollow;
    $[5] = properties.loading;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <div className="bg-transparent-secondary lg:border-outline-thin mx-[-24px] h-[180px] min-w-[200px] pb-6 pl-6 pt-[18px] md:min-w-[360px] lg:mx-0 lg:h-[180px] lg:rounded-[12px] lg:border xl:max-w-[864px] rtl:pl-0 rtl:pr-6" hidden={t1}>{t2}{t3}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};